import dayjs, { Dayjs } from 'dayjs';

export interface CompareDateRange {
  startDate: Dayjs;
  endDate: Dayjs;
}

export interface ClampedCompareRange {
  range: CompareDateRange;
  clampedToMin: boolean;
  clamped: boolean;
}

const dayKey = (d: Dayjs) => dayjs(d).format('YYYY-MM-DD');

// Keep compare dates inside [minDate, day before current start].
export function clampCompareRange(
  range: CompareDateRange,
  min: Dayjs | undefined | null,
  currentStart: Dayjs
): ClampedCompareRange {
  const max = currentStart.subtract(1, 'day');
  let start = range.startDate;
  let end = range.endDate;

  if (min && dayKey(start) < dayKey(min)) {
    start = min;
  }
  if (min && dayKey(end) < dayKey(min)) {
    end = min;
  }
  if (dayKey(end) > dayKey(max)) {
    end = max;
  }
  if (dayKey(start) > dayKey(end)) {
    start = end;
  }

  return {
    range: { startDate: start, endDate: end },
    clampedToMin: !!min && dayKey(range.startDate) < dayKey(min),
    clamped:
      dayKey(start) !== dayKey(range.startDate) ||
      dayKey(end) !== dayKey(range.endDate)
  };
}

export function isCompareUnavailable(
  currentStart: Dayjs,
  min: Dayjs | undefined | null
): boolean {
  return !!(min && !currentStart.isAfter(min, 'day'));
}
